function selectPlan(field) {
    const selectId = field.getAttribute('data-servicing-plan-select-id'),
          url = field.value;

    let button;

    if (selectId) {
        button = document.querySelector(`[data-for-servicing-plan-select=${selectId}]`);
    }
    
    if (button) {
        button.setAttribute('href', url);
    }
}

function trackOpen(button) {
    const params = {
        utm_medium: button.getAttribute('data-utm-medium'),
        utm_campaign: button.getAttribute('data-utm-campaign'),
        utm_source: button.getAttribute('data-utm-source'),
    };

    const query = new URLSearchParams(params),
          queryString = query.toString(),
          url = button.getAttribute('href');

    dataLayer.push({
        'event': 'VirtualPageview',
        'virtualPageURL': url + '&' + queryString,
        'virtualPageTitle': 'Servicing'
    });
}

function init() {
    const selectFields = document.querySelectorAll('[data-servicing-plan-select-id'),
          buttons = document.querySelectorAll('.js_emacFormOverlay');
    
    buttons.forEach(button => {
        $(button).mtcOverlay({
            buttonHtml: '<div class="overlayCloseButton"><a href="#"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" fill="currentColor"><path d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"/></svg><span class="sr-only">Close</span></a></div>',
            contentClass: 'emacFormOverlay',
            beforeOpen: () => trackOpen(button),
        })
    });
}

$(document).ready(init);
